import { AxiosRequestConfig } from "axios";

import { put } from "@api/httpClient";

interface PutApplicantsExamsResultsSubmitParams {
  challengeResultId: number;
  examId: number;
  options: AxiosRequestConfig;
}

export async function putApplicantsExamsResultsSubmit({
  challengeResultId,
  examId,
  options,
}: PutApplicantsExamsResultsSubmitParams) {
  const { data } = await put(
    `/api/applicants/exams/${examId}/results/${challengeResultId}/submit`,
    options,
  );

  return data;
}
